import getAxios from '@/utils/axios-request'

export async function getCentralRegisterList(limit, offset = 0, filter = {}) {
  const axios = await getAxios()
  let query = ''
  if (filter.developerId) {
    query += `&tsp_id=${filter.developerId}`
  }
  if (filter.providerId) {
    query += `&provider_id=${filter.providerId}`
  }
  if (filter.industry) {
    query += `&industry=${filter.industry}`
  }
  return axios({
    url: `/api/v1/services/central_register?${limit === 0 ? '' : `limit=${limit}&`}offset=${offset}${query === '' ? '' : query}`,
    method: 'get'
  })
}
